import PropTypes from 'prop-types';

interface InteractionDisabledOverlayProps {
    isVisible: boolean;
    type: string;
  }
  
  const InteractionDisabledOverlay: React.FC<InteractionDisabledOverlayProps> = (props:InteractionDisabledOverlayProps) => {
    if (!props.isVisible) return null;

    let style = {}

    switch (props.type){
        case "pathway_node":
            style ={
                position: 'absolute',
                top: 100,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                zIndex: 1200,
                color: 'pink',
                fontSize: '20px'
              };
              break;
        case "pathway_main":
        style ={
            position: 'absolute',
            top: 320,
            left: 0,
            right: 0,
            bottom: 0,
            height:"200%",
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            zIndex: 1200,
            color: 'pink',
            fontSize: '20px',
            flexGrow: 1
            };
            break;
        case "interval_set" :
            style ={
                position: 'absolute',
                top: 70,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                zIndex: 1200,
                color: 'pink',
                fontSize: '20px'
            };
          break;
          default:
            style ={
                position: 'absolute',
                top: 100,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                zIndex: 1200,
                color: 'pink',
                fontSize: '20px'
              };
              break;
    }

  
    return (
      <div style={style}>
        <br/>
        Shared entity is locked for editing. Click the Unlock icon to edit.
      </div>
    );
  };
  

  InteractionDisabledOverlay.propTypes = {
    isVisible: PropTypes.bool.isRequired
  };


  export default InteractionDisabledOverlay;